export const getCommentYear = (state, id) => state.persistStore.settings?.TARGET_ACTUAL_COMMENT_YEAR || '';
